import { Instrument } from '@/api/types';
import { InstrumentType } from '@/utils/leverageOptions';

export function resolveInstrumentType(instrument?: Instrument): InstrumentType {
    const primary = instrument?.instrument_type?.primary_type;
    if (
        primary === 'forex' ||
        primary === 'crypto' ||
        primary === 'stock' ||
        primary === 'commodity'
    ) {
        return primary;
    }
    if (instrument?.instrument_type?.is_crypto) {
        return 'crypto';
    }
    if (instrument?.instrument_type?.is_stock) {
        return 'stock';
    }
    if (instrument?.instrument_type?.is_commodity) {
        return 'commodity';
    }
    return 'forex';
}

export function buildInstrumentRealTimePrice(instrument?: Instrument) {
    if (!instrument?.current_price || instrument.current_price <= 0) {
        return undefined;
    }

    const mid = Number(instrument.current_price);
    const spread = Number(instrument.spread ?? mid * 0.0001);

    return {
        bid: mid - spread / 2,
        ask: mid + spread / 2,
        symbol: instrument.symbol,
    };
}
